import {Popup} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import React from 'react';

import { EVENT_CONTENT_VARIANT_STANDARD_FEED} from '@constants/variables';
import Chip from '@ui/Chip';
import {convertToInt} from '@utils/helpers';

export const EventContentVariantPopup = ({
    eventContentVariant,
    className = '--marginLeft-0-5-em contentVariantLabel',
}) => {
    if (!eventContentVariant || convertToInt(eventContentVariant.id) === EVENT_CONTENT_VARIANT_STANDARD_FEED) {

        return null;
    }

    return (
        <Popup
            trigger={
                <span>
                    <Chip
                        size='small'
                        color='primary'
                        className={className}
                        label={eventContentVariant.short_name}
                    />
                </span>
            }
            content={eventContentVariant.name}
            size='small'
            hoverable
        />
    );
};

EventContentVariantPopup.propTypes = {
    eventContentVariant: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        short_name: PropTypes.string,
    }),
    className: PropTypes.string,
};
